import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog.tsx'
import { useTranslation } from 'react-i18next'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader.tsx'
import DialogBody from '@/components/_custom/DialogBody/DialogBody.tsx'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import { Close, Delete } from '@mui/icons-material'
import { useMutation } from '@apollo/client'
import { MealHabit } from '@/types/Meal.ts'
import { DELETE_DAYCARE_MEAL_HABIT } from '@/modules/API/meal/daycareSettingsHandler.ts'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import styles from '../meal.module.scss'

interface ConfirmDeleteMealHabitDialogProps {
    open: boolean
    handleClose: () => void
    daycareId: number
    habit: MealHabit
    refetch: () => void
}

const ConfirmDeleteMealHabitDialog: FunctionComponent<ConfirmDeleteMealHabitDialogProps> = ({
    open,
    handleClose,
    daycareId,
    habit,
    refetch
}: ConfirmDeleteMealHabitDialogProps) => {
    const { t } = useTranslation()
    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deleteMealHabit] = useMutation(DELETE_DAYCARE_MEAL_HABIT, {
        variables: {
            daycareId,
            id: habit.id
        },
        onCompleted: () => {
            refetch()
            showNotificationSuccess(t('mealHabitDeleted'))
            handleClose()
        },
        onError: () => {
            showNotificationError(t('mealHabitDeletedError'))
            handleClose()
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('deleteMealHabit')} />
            <DialogBody className={styles.DialogBody}>
                <div className={styles.TextContainer}>
                    <p className={styles.Text}>
                        {t('deleteMealHabitMessage')} <span>{habit.habit}</span> ?{' '}
                    </p>
                    <p className={styles.Text}>{t('noRollBack')}</p>
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={() => deleteMealHabit()}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ConfirmDeleteMealHabitDialog
